import { render, staticRenderFns } from "./CreateOpportunity.vue?vue&type=template&id=1f065c59&scoped=true"
import script from "./CreateOpportunity.vue?vue&type=script&lang=js"
export * from "./CreateOpportunity.vue?vue&type=script&lang=js"
import style0 from "./CreateOpportunity.vue?vue&type=style&index=0&id=1f065c59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f065c59",
  null
  
)

export default component.exports